import * as React from 'react'

import { Box, Icon, Text } from '@factorialco/deprecated-design-system'
import { groupBy } from 'lodash'

import i18n from 'modules/core/lib/i18n'

import { TemplateWeek } from 'modules/shift_management/lib/types'

interface ColorCodeTemplateWeekProps {
  templateWeek: TemplateWeek
}

const ColorCodeTemplateWeek = ({ templateWeek }: ColorCodeTemplateWeekProps) => {
  const { name, color } = templateWeek
  return (
    <Box
      flexDirection="row"
      width="fit-content"
      alignItems="center"
      justifyContent="spaceBetween"
      background="grey200"
      borderRadius={{ all: 'abs100' }}
      padding="s4"
      paddingRight="s12"
      gap="s4"
    >
      <Icon.Small icon="circle" color={color || 'grey400'} />
      <Box maxWidth="s200">
        <Text size="200" weight="semibold" color="grey800" ellipsis>
          {name}
        </Text>
      </Box>
    </Box>
  )
}

export interface Props {
  templateWeeks: TemplateWeek[]
}

const TemplateWeeks = ({ templateWeeks }: Props) => {
  const templateWeeksGroupedByTemplate = groupBy(templateWeeks, 'templateId')

  return (
    <Box alignItems="flexStart" gap="s8">
      <Text.Normal size="300" weight="medium" color="grey1000">
        {i18n.t('shift_management.default_shift.colors.rotating_shifts')}
      </Text.Normal>
      {Object.entries(templateWeeksGroupedByTemplate).map(([, templateWeeks]) => {
        const templateId = templateWeeks[0]!.templateId
        const templateName = templateWeeks[0]!.templateName
        return (
          <Box flexDirection="column" justifyContent="spaceBetween" key={templateId} gap="s8">
            <Text.Normal size="200">{templateName}</Text.Normal>
            {templateWeeks.map((templateWeek: TemplateWeek) => (
              <ColorCodeTemplateWeek key={templateWeek.id} templateWeek={templateWeek} />
            ))}
          </Box>
        )
      })}
    </Box>
  )
}

export default TemplateWeeks
